import { Component, OnInit } from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { UserserviceService } from '../userservice.service';
import { UploadFileService } from '../upload-file.service';
import { CountriesService } from '../countries.service';
import { countriesData } from '../data';
import { popup } from '../popup';
import { ModelserviceService } from '../modelservice.service';
@Component({
    selector: 'app-payment-details',
    templateUrl: './payment-details.component.html',
    styleUrls: ['./payment-details.component.css'],
})
export class PaymentDetailsComponent implements OnInit {
    DetailsForm!: FormGroup;
    signUpForm!: FormGroup;
    uid: any = '';
    policy: boolean = false;
    // countriesData = countriesData;
    states: any;
    selectedCountry: any;
    initialState: any = 'IN';
    phonecode: any = '';
    constructor(
        private router: Router,
        private formbuilder: FormBuilder,
        private userService: UserserviceService,
        private uploadImage: UploadFileService,
        private CountryService: CountriesService,
        private openModel: ModelserviceService
    ) {
        this.signUpForm = this.formbuilder.group(
            {
                email: ['', [Validators.required, Validators.email]],
                password: ['', [Validators.required, Validators.minLength(8)]],
                confirmpassword: ['', Validators.required],
            },
            { validators: this.passwordMatchValidator }
        );

        this.DetailsForm = this.formbuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            mobileNumber: ['', Validators.required],
            companyName: ['', Validators.required],
            city: ['', Validators.required],
            state: ['', Validators.required],
            country: ['', Validators.required],
            address1: ['', Validators.required],
            address2: [''],
            postCode: ['', Validators.required],
        });
    }

    countries: any;
    ngOnInit(): void {
        this.getCountry();
        //  this.selectCountry=this.initialState;
        // this.CountryService.getCountries().subscribe({
        //   next:(res)=>{
        //   this.countries=res;
        //   console.log(this.countries)
        //   },
        //   error:(err)=>{
        //     console.log(err)
        //   }
        // })
        // if (phoneNumberObj) {
        //   const countryCode = phoneNumberObj.countryCallingCode;
        //   console.log('Country Code:', countryCode);
        // }
    }

    passwordMatchValidator(
        control: AbstractControl
    ): { [key: string]: boolean } | null {
        const password = control.get('password')?.value;
        const confirmPassword = control.get('confirmpassword')?.value;
        // Check if confirm password is empty
        if (!confirmPassword) {
            control.get('confirmpassword')?.setErrors({ required: true });
            return { required: true };
        }
        if (password !== confirmPassword) {
            control
                .get('confirmpassword')
                ?.setErrors({ passwordMismatch: true });
            return { passwordMismatch: true };
        }

        return null;
    }

    getCountry() {
        this.CountryService.getCountries().subscribe({
            next: (res) => {
                this.countries = res;
                console.log(this.countries);
            },
            error(err) {
                console.log(err);
            },
        });
    }

    passwordVisible: boolean = false;
    togglePasswordVisibility() {
        this.passwordVisible = !this.passwordVisible;
    }

    isSignup: boolean = true;

    passwordVisible1: boolean = false;
    togglePasswordVisibility1() {
        this.passwordVisible1 = !this.passwordVisible1;
    }
    // flag:string='https://flagcdn.com/w320/in.png'
    // selectedNumber(){
    //   this.selectedCountry
    //   this.countries.filter((x:any)=>{
    //     if(x.flag==this.selectCountry){
    //      this.flag=x.flags.png
    //     }
    //   })
    // }

    isClicked: boolean = false;

    // signUp(){
    //   this.isClicked=true;
    //   this.userService.createUserDetailInFirebase(this.signUpForm.value).then(result=>{
    //     this.uid=result;
    //     console.log('user created',this.uid)
    //     // this.isSignup=false;
    //     this.router.navigate(['/login'])
    //   }).catch(err=>{
    //     console.log(err)
    //   })
    // }
    popup!: popup;
    signUpPopup() {
        this.popup = {
            header: 'Email Exists!',
            mainContent: 'Email already exists. Please try logging in.',
            leftButton: '',
            rightButton: 'Ok',
        };
        this.openModel.openModel(this.popup);
    }

    signUp() {
        this.isClicked = true;
        if (!this.signUpForm.valid) {
            this.signUpForm.markAllAsTouched();
            this.isClicked = false;
            return;
        }
        this.userService
            .createUserDetailInFirebase(this.signUpForm.value)
            .then((result) => {
                this.uid = result;
                this.router.navigate(['/login']);
            })
            .catch((err: any) => {
                if (err?.code === 'auth/email-already-in-use') {
                    this.signUpPopup();
                }

                this.isClicked = false;
            });
    }



    selectCountry: any;
    check() {
        this.policy = !this.policy;
        console.log(this.policy);
        console.log(this.DetailsForm.value);
    }

    // selectCountry1(){
    //   const selectedCountry=this.DetailsForm.value.country;
    //   this.countriesData.filter((x:any)=>{
    //     if(x.country==selectedCountry){
    //       this.states=x.states
    //     }
    //   })
    // }

    // city:any;
    //   selectState(event:any){
    //     const selectedValue = event.target.value;
    //     this.states.filter((x:any)=>{
    //       if(x.state==selectedValue){
    //         this.city=x.districts;
    //       }
    //     })
    //   }

    //   formatMobileNumber(event: Event) {
    //     const input = event.target as HTMLInputElement;
    //     let value = input.value.replace(/\D/g, ''); // Remove all non-digit characters

    //     if (value.startsWith('1')) {
    //         // For US phone numbers
    //         if (value.length > 1) {
    //             value = `${value.slice(0, 1)}-${value.slice(1)}`;
    //         }
    //         if (value.length > 5) {
    //             value = `${value.slice(0, 5)}-${value.slice(5)}`;
    //         }
    //         if (value.length > 9) {
    //             value = `${value.slice(0, 9)}-${value.slice(9)}`;
    //         }
    //         if (value.length > 12) {
    //             value = `${value.slice(0, 12)}-${value.slice(12)}`;
    //         }
    //     } else if (value.startsWith('91')) {
    //         // For Indian phone numbers
    //         if (value.length > 2) {
    //             value = `${value.slice(0, 2)}-${value.slice(2)}`;
    //         }
    //         if (value.length > 6) {
    //             value = `${value.slice(0, 6)}-${value.slice(6)}`;
    //         }
    //         if (value.length > 10) {
    //             value = `${value.slice(0, 10)}-${value.slice(10)}`;
    //         }
    //         if (value.length > 13) {
    //             value = `${value.slice(0, 13)}-${value.slice(13)}`;
    //         }
    //     }
    //     // Add more conditions for other country codes as needed

    //     input.value = value;
    // }

    // imageResponse:any;
    // baseUrl:String='https://contech-media-company-logo.s3.us-east-1.amazonaws.com/';
    // onimageSelected(event: any) {
    //   const selectedFile = event.target.files[0];
    //   if (selectedFile) {
    //     const folderName = 'contech-media-user-image';
    //     const fileName = selectedFile.name;

    //     // Call the uploadFileToS3 function from your S3Service
    //     this.uploadImage.uploadCompanyProfile(selectedFile, `${folderName}/${fileName}`)
    //       .then((response) => {
    //         console.log('File uploaded successfully:', response);
    //         this.imageResponse = response;
    //         this.DetailsForm.controls['imageURL'].setValue(this.imageResponse.Key)
    //       })
    //       .catch((error) => {
    //         // Handle any errors that occur during the upload
    //         console.error('Error uploading file:', error);
    //       });
    //   } else {
    //     // Handle the case where no file is selected
    //     console.error('No file selected for upload');
    //   }
    // }
    isLoading: boolean = false;
    submit() {
        this.isLoading = true;
        this.userService
            .updateUserFirebase(this.DetailsForm.value, this.uid)
            .then((result) => {
                this.isLoading = false;
                console.log(result);
                this.router.navigate(['/login']);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    //  passwordValidator(): ValidatorFn {
    //   return (control: AbstractControl): { [key: string]: any } | null => {
    //     const password = control.value;

    //     if (!password) {
    //       return null;
    //     }

    //     // Check for at least one capital letter
    //     const capitalLetterPattern = /[A-Z]/;
    //     if (!capitalLetterPattern.test(password)) {
    //       return { missingCapitalLetter: true };
    //     }

    //     // Check for at least one number
    //     const numberPattern = /[0-9]/;
    //     if (!numberPattern.test(password)) {
    //       return { missingNumber: true };
    //     }

    //     // Check for at least one special character
    //     const specialCharacterPattern = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/;
    //     if (!specialCharacterPattern.test(password)) {
    //       return { missingSpecialCharacter: true };
    //     }

    //     return null;
    //   };
    // }

    // passwordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
    //   const password = control.get('password')?.value;
    //   const confirmPassword = control.get('confirmpassword')?.value;
    //   // Check if confirm password is empty
    //   if (!confirmPassword) {
    //     control.get('confirmpassword')?.setErrors({ required: true });
    //     return { 'required': true };
    //   }
    //   if (password !== confirmPassword) {
    //     control.get('confirmpassword')?.setErrors({ passwordMismatch: true });
    //     return { 'passwordMismatch': true };
    //   }

    //   return null;
    // }

    //  parsePhoneNumberFromString(phoneNumber: string, arg1: string) {
    //   throw new Error('Function not implemented.');
    // }
}
